import { render } from "./UrlList.vue?vue&type=template&id=e232f04a"
import script from "./UrlList.vue?vue&type=script&lang=js"
export * from "./UrlList.vue?vue&type=script&lang=js"

import exportComponent from "/var/app/current/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__